export default __webpack_public_path__ + "static/media/proximanova.304da30a.ttf";